namespace('IO.Views.Customers', function (exports) {
  'use strict';

  var Show = IO.Views.Customers.New;

  exports.Show = Show;
});
